module.exports = __webpack_public_path__ + "img/CD.01aaecd6.svg";